import { Component, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CrewChangeServices } from '../crew-change.service';
import { KeycloakService } from '../../../../authentication/keycloak.service';
import { forkJoin } from 'rxjs';
import { OrganisationService } from 'src/app/organisation/organisation.service';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import { DocumentReference } from '../../../../documents/documents.service';
import {
  PgSubTitleComponent,
  PgTitleComponent
} from '../../../../shared/components/title-bar/title-bar.component';
import { Vessel, VesselsService } from '../../vessels.service';
import { ActivatedRoute } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { CrewAssignmentsComponent } from '../crew-assignments/crew-assignments.component';
import { MatCardModule } from '@angular/material/card';
import { MaterialAutoCompleteComponent } from 'src/app/shared/components/material-autocomplete/material-auto-complete.component';
import { MaterialOrganisationSelectorComponent } from 'src/app/shared/components/material-autocomplete/material-organisationselector.component';
import { MatSelectModule } from '@angular/material/select';
import { MaterialPgInputComponent } from 'src/app/shared/components/material-pg-input/material-pg-input.component';
import { MaterialChunkFileUploadComponent } from 'src/app/shared/components/material-file-uploader/material-chunk-file-upload.component';
import { MatButtonModule } from '@angular/material/button';
import { Crew, CrewAppraisal } from 'src/app/generated/services/transportation/crew/crew';
import { CrewServiceSpa } from 'src/app/generated/services/transportation/crew/crewSpa';
import { MaterialPdfViewerComponent } from 'src/app/shared/components/material-pdf-viewer/material-pdf-viewer.component';
import { LookupServiceSpa } from 'src/app/generated/services/lookups/lookupSpa';

@Component({
  selector: 'app-appraisal',
  templateUrl: './crew-appraisal.component.html',
  styleUrls: ['./crew-appraisal.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SharedModule,
    CrewAssignmentsComponent,
    MatCardModule,
    MaterialAutoCompleteComponent,
    MatSelectModule,
    MaterialOrganisationSelectorComponent,
    MaterialPgInputComponent,
    MaterialChunkFileUploadComponent,
    MatButtonModule, MaterialPdfViewerComponent],
})
export class CrewAppraisalComponent implements OnInit, PgTitleComponent, PgSubTitleComponent {

  title = new EventEmitter<string>();
  subTitle = new EventEmitter<string>();
  crews: Crew[] = [];
  selectedCrew = Crew.create();
  master = Crew.create();
  assessor = Crew.create();
  crewId!: string;
  rank!: string;
  ranks: string[] = [];

  crewAppraisal = CrewAppraisal.create();

  _appraisalDate!: string;
  document!: DocumentReference;

  technicalManagements: Organisation[] = [];
  _selectedTechnicalManagement = Organisation.create();
  doc?: DocumentReference;

  get selectedTechnicalManagement() {
    return this._selectedTechnicalManagement;
  }

  set selectedTechnicalManagement(value: Organisation) {
    if (value) {
      this._selectedTechnicalManagement = value;
    }
  }

  get appraisalDate() {
    return this._appraisalDate;
  }

  set appraisalDate(value: string) {
    if(value) {
      this._appraisalDate = value;
    }
  }

  vessels: Vessel[] = [];
  selectedVessel = Vessel.create();

  constructor(private _crewChangeService: CrewChangeServices,
              private _vesselsService: VesselsService,
              private _organisationService: OrganisationService,
              private _keycloakService: KeycloakService,
              private _activateRoute: ActivatedRoute,
            private _lookupServiceSpa: LookupServiceSpa,
            private _crewService: CrewServiceSpa,
  ) { }

  ngOnInit(): void {
    this._activateRoute.paramMap.subscribe(p => {
      this.crewId = p.get('id') || '';
      forkJoin([
        this._organisationService.get(),
        this._crewService.getCrew({}),
        this._lookupServiceSpa.getLookupItems({categoryName: 'ranks'}),
        this._crewService.getCrewById({id: this.crewId}),
        this._vesselsService.getActiveVessels(),
      ]).subscribe((results) => {
        this.technicalManagements = results[0].filter(s => s.properties['technical'] === true);
        this.crews = results[1].crews.map(c => c.data).filter(c => c !== undefined);
        this.ranks = results[2].items.map(i => i.values[0]).filter(r => results[3].data?.crewChanges.map(c => c.rank).includes(r));
        this.vessels = results[4].filter(v => results[3].data?.crewChanges.map(c => c.vesselImo).includes(v.imo));
        this.selectedCrew = results[3].data || Crew.create();
        this.title.emit(`${this.selectedCrew.firstName} ${this.selectedCrew.lastName} Officer Appraisal`);
      });
    });
  }

  crewFormatter(crew: Crew) {
    if (crew){
      return `${crew.firstName} ${crew.lastName} ${crew.passportDetails!.number}`;}
    return '';
  }

  rankFormatter(data: any) {
    return data;
  }

  selectCrew(selectedCrew: Crew) {
    if (selectedCrew) {
      this.selectedCrew = selectedCrew;
    }
  }

  hasRole(roleName: string) {
    return this._keycloakService.hasRole(roleName);
  }

  add() {
    // this._crewChangeService.getCrewAppraisalItems(this.document.id).subscribe(items => {
    //   this.crewAppraisal = {
    //     id: uuidv4(),
    //     date: this.appraisalDate,
    //     documentId: this.document.id,
    //     items,
    //     masterId: this.master.id,
    //     assessorId: this.assessor.id
    //   };
    //   this.selectedCrew.actions.push(this._actionService.userAction(ActionType.Update));
    //   this.selectedCrew.appraisals.push(this.crewAppraisal);
    //   this._crewChangeService.updateCrew(this.selectedCrew).subscribe({
    //     next: () => {
    //       this._pgMessagesService.publishMessage({
    //         level: MessageLevel.Info,
    //         topic: 'Crew Appraisal',
    //         message: `Appraisal for ${this.selectedCrew.firstName} ${this.selectedCrew.lastName} added.`
    //       });
    //     },
    //     error: () => {
    //       this._pgMessagesService.publishMessage({
    //         level: MessageLevel.Error,
    //         topic: 'Crew Appraisal',
    //         message: `Could not add appraisal for ${this.selectedCrew.firstName} ${this.selectedCrew.lastName}.`
    //       });
    //     }
    //   });
    // });
  }

  documentFileAdded(documentReference: DocumentReference) {
    this.document = documentReference;
  }
}
